export const WORKFLOW_AI_SESSION_LOADING = 'WORKFLOW_AI_SESSION_LOADING';
export const WORKFLOW_AI_SESSION_SUCCESS = 'WORKFLOW_AI_SESSION_SUCCESS';
export const WORKFLOW_AI_SESSION_FAILURE = 'WORKFLOW_AI_SESSION_FAILURE';
export const WORKFLOW_AI_GENERATE_START = 'WORKFLOW_AI_GENERATE_START';
export const WORKFLOW_AI_GENERATE_DONE = 'WORKFLOW_AI_GENERATE_DONE';
export const WORKFLOW_AI_RESTORE_START = 'WORKFLOW_AI_RESTORE_START';
export const WORKFLOW_AI_RESTORE_DONE = 'WORKFLOW_AI_RESTORE_DONE';
export const WORKFLOW_AI_CLEAR = 'WORKFLOW_AI_CLEAR';

const initialState = {
  session: null,
  messages: [],
  versions: [],
  loadingSession: false,
  generating: false,
  restoringVersionId: null,
  error: null,
};

export default function workflowAiReducer(state = initialState, action) {
  switch (action.type) {
    case WORKFLOW_AI_SESSION_LOADING:
      return { ...state, loadingSession: true, error: null };
    case WORKFLOW_AI_SESSION_SUCCESS:
      return {
        ...state,
        loadingSession: false,
        session: action.payload.session,
        messages: action.payload.messages || [],
        versions: action.payload.versions || [],
        error: null,
      };
    case WORKFLOW_AI_SESSION_FAILURE:
      return { ...state, loadingSession: false, error: action.payload };
    case WORKFLOW_AI_GENERATE_START:
      return { ...state, generating: true, error: null };
    case WORKFLOW_AI_GENERATE_DONE:
      return {
        ...state,
        generating: false,
        session: action.payload.session ?? state.session,
        messages: action.payload.messages ?? state.messages,
        versions: action.payload.versions ?? state.versions,
        error: action.payload.error || null,
      };
    case WORKFLOW_AI_RESTORE_START:
      return { ...state, restoringVersionId: action.payload, error: null };
    case WORKFLOW_AI_RESTORE_DONE:
      return { ...state, restoringVersionId: null, error: action.payload?.error || null };
    case WORKFLOW_AI_CLEAR:
      return initialState;
    default:
      return state;
  }
}
